// @flow

// $FlowIssue
const path = require("node:path");
const {
  readdirSync,
  statSync,
  readFileSync,
  writeFileSync,
  // $FlowIssue
} = require("node:fs");

const mergeWith = require("lodash/mergeWith");
const { LayoutHintConfiguration } = require("../constants/LayoutHintConfig");

const findFiles = (dir: string): Array<string> => {
  const matchedFiles = [];

  const files = readdirSync(dir);

  for (const file of files) {
    const absolute = path.join(dir, file);
    if (statSync(absolute).isDirectory()) {
      const foundFiles = findFiles(absolute);
      matchedFiles.push(...foundFiles);
    } else {
      const filename = path.basename(file);
      if (filename === "LayoutHintConfig.json") {
        matchedFiles.push(absolute);
      }
    }
  }

  return matchedFiles;
};

/**
 * Merge all LayoutHintConfig.json files from this library and in the srcFolder
 * together into one config file, and copies it to the outputFolder.<br/>
 * This file is consumed by Be Informed studio to give layout hint information
 */
exports.mergeLayoutHintConfigurations = async (
  srcFolder: string,
  outputFolder: string,
): Promise<void> => {
  // $FlowIssue
  const escapedSrcFolder = srcFolder.replaceAll("\\", "/");

  const files = findFiles(escapedSrcFolder);

  const jsons = files.map((file) => {
    const content = readFileSync(file, "utf-8");
    return JSON.parse(content);
  });

  // Function to merge arrays during merging
  const customizer = (objValue: Object, srcValue: Object): Object => {
    if (Array.isArray(objValue)) {
      return [...new Set([...objValue, ...srcValue])];
    }
  };

  const newConfig = mergeWith(LayoutHintConfiguration, ...jsons, customizer);

  writeFileSync(
    path.join(outputFolder, "LayoutHintConfig.json"),
    JSON.stringify(newConfig),
  );
};
